import { formatBalance } from '@ui/src';
import { useAppSelector } from '@store';
import { TransactionTypeEnum } from '../../../hoc/customers/types';
import BaseStatisticItem from './base-statistic-item';
import { BaseStatisticTypes } from './types';

import cn from './statistic.module.css';

const BaseStatistic = ({
  baseStatistic,
  customersTransactionTypes,
  baseCurrency,
}: BaseStatisticTypes): React.JSX.Element => {
  const { currenciesList } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const incomingType = customersTransactionTypes?.find(
    (item) => item.name === TransactionTypeEnum.INCOMING,
  );
  const outgoingType = customersTransactionTypes?.find(
    (item) => item.name === TransactionTypeEnum.OUTGOING,
  );

  const incomingStats = baseStatistic?.find(
    (item) => item.typeId === incomingType?.id,
  );

  const outgoingStats = baseStatistic?.find(
    (item) => item.typeId === outgoingType?.id,
  );

  const currentCurrency = currenciesList?.find(
    (item) => item.id === baseCurrency?.id,
  );

  return (
    <div className={cn.baseStatisticContent}>
      <div className={cn.baseStatisticBlock}>
        <BaseStatisticItem
          title="Incoming transaction"
          value={incomingStats?.count.toString() as string}
        />
        <BaseStatisticItem
          title="Outgoing transaction"
          value={outgoingStats?.count.toString() as string}
        />
      </div>
      <div className={cn.baseStatisticBlock}>
        <BaseStatisticItem
          title="Av. value incoming payment"
          value={`${formatBalance(
            incomingStats?.avgValue || 0,
            currentCurrency,
          )} ${baseCurrency?.name}`}
        />
        <BaseStatisticItem
          title="Av. value outgoing payment"
          value={`${formatBalance(
            outgoingStats?.avgValue || 0,
            currentCurrency,
          )} ${baseCurrency?.name}`}
        />
      </div>
      <div className={cn.baseStatisticBlock}>
        <BaseStatisticItem
          title="Min. value incoming payment"
          value={`${formatBalance(
            incomingStats?.minValue || 0,
            currentCurrency,
          )} ${baseCurrency?.name}`}
        />
        <BaseStatisticItem
          title="Max. value incoming payment"
          value={`${formatBalance(
            incomingStats?.maxValue || 0,
            currentCurrency,
          )} ${baseCurrency?.name}`}
        />
      </div>
      <div className={cn.baseStatisticBlock}>
        <BaseStatisticItem
          title="Min. value outgoing payment"
          value={`${formatBalance(
            outgoingStats?.minValue || 0,
            currentCurrency,
          )} ${baseCurrency?.name}`}
        />
        <BaseStatisticItem
          title="Max. value outgoing payment"
          value={`${formatBalance(
            outgoingStats?.maxValue || 0,
            currentCurrency,
          )} ${baseCurrency?.name}`}
        />
      </div>
    </div>
  );
};

export default BaseStatistic;
